import { render } from "./TimeSlotClass.vue?vue&type=template&id=6fdfa4c3&scoped=true"
import script from "./TimeSlotClass.vue?vue&type=script&lang=js"
export * from "./TimeSlotClass.vue?vue&type=script&lang=js"

import "./TimeSlotClass.vue?vue&type=style&index=0&id=6fdfa4c3&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fdfa4c3"]])

export default __exports__